export default __webpack_public_path__ + "static/media/about.f6213c39.jpg";